import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NbIconLibraries } from '@nebular/theme';

import { ConfigurationService } from './common/config/configuration.service';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'ngx-app',
  template: '<router-outlet *ngIf="!isIframe"></router-outlet>',
})
export class AppComponent implements OnInit {
  public isIframe = false;

  constructor(
    private router: Router,
    private configurationService: ConfigurationService,
    private translate: TranslateService,
    private msalService: MsalService,
    private iconLibraries: NbIconLibraries,
  ) {
    this.iconLibraries.registerFontPack('font-awesome', { packClass: 'fa' });
    translate.setDefaultLang('en');
    translate.use('en');
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };
  }

  ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;

    const appConfig = this.configurationService.getAppConfig();
    this.translate.use(appConfig.appConfig.defaultLanguage);

    window.addEventListener('beforeunload', () => {
      this.msalService.logout({
        onRedirectNavigate: () => {
          return false;
        },
      });
    });
  }
}
